<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
    v-if="userCompanies"
  >
    <template #button-content v-if="defaultMerchant">
      <span
        ><strong>{{ defaultMerchant }}</strong></span
      >
      <feather-icon
        badge-classes="bg-danger"
        class="text-body"
        icon="ChevronDownIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Your Mechants</h4>
        <b-badge pill variant="light-primary">
          {{ merchantCounter }}
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      v-once
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
      v-if="companies"
    >
      <div v-for="(item, index) in companies" :key="index">
        <!-- System Notification Toggler -->
        <div class="media d-flex align-items-center">
          <h6 class="font-weight-bolder mr-auto mb-0">
            {{ item.name != null ? item.name : "Company Name: " + index }}
          </h6>
        </div>
        <!-- Account Notification -->
        <b-link
          v-for="(value, key) in item.merchants"
          :key="key"
          @click.native="handelDefaultMerchant(value)"
        >
          <b-media>
            <template #aside>
              <b-avatar
                size="32"
                :variant="
                  defaultMerchantId == value.id ? 'success' : 'light-info'
                "
              >
                <feather-icon
                  :icon="
                    defaultMerchantId == value.id ? 'CheckIcon' : 'ListIcon'
                  "
                />
              </b-avatar>
            </template>
            <p class="media-heading">
              <span class="font-weight-bolder">
                {{ value.name }}
              </span>
            </p>
            <small class="notification-text">{{
              value.authorizationShortCode
            }}</small>
          </b-media>
        </b-link>
      </div>
    </vue-perfect-scrollbar>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import axios from "@axios";

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      companies: null,
      defaultMerchantId: null,
      defaultMerchant: "",
      merchantCounter: 0,
    };
  },
  props: {
    userCompanies: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    userCompanies: {
      immediate: true,
      handler(val) {
        if (!val || val.length === 0) return;
        this.defaultMerchantId = JSON.parse(
          localStorage.getItem("defaultMerchantId"),
        ); // read here, not in data()
        this.companies = val;
        this.merchantCounter = 0;
        val.forEach((element) => {
          this.merchantCounter += element.merchants.length;
          element.merchants.forEach((value) => {
            if (value.id === this.defaultMerchantId) {
              this.defaultMerchant = value.name;
            }
          });
        });
      },
    },
  },
  methods: {
    // fetchData() {
    //   this.companies = this.userCompanies;
    //   this.companies.forEach((element) => {
    //     this.merchantCounter += element.merchants.length;
    //     element.merchants.forEach((value) => {
    //       if (value.id === this.defaultMerchantId) {
    //         localStorage.setItem(
    //           "defaultMerchantId",
    //           JSON.stringify(this.defaultMerchantId),
    //         );
    //         this.defaultMerchant = value.name;
    //         this.defaultMerchantId = value.id;
    //       }
    //     });
    //   });
    // },
    handelDefaultMerchant(item) {
      localStorage.setItem("defaultMerchantId", JSON.stringify(item.id));
      this.$router.go();
    },
  },
};
</script>

<style></style>
